import React from 'react';
import PropTypes from 'prop-types';
import api from '@tutorbot/directory-api';
import Blog from '../blog';
import Error from '../_error';

const BlogCategory = ({ categories, category }) => {
  if (!categories) {
    return <Error />;
  }

  if (category === 'languages') {
    return (
      <Blog
        categories={categories}
        small
        noHeader
        seeMoreRoute="blogSubCategory"
        category={category}
      />
    );
  }

  return (
    <Blog
      categories={categories}
      seeMoreRoute="blogSubCategory"
      small={false}
      noHeader={false}
      category={category}
    />
  );
};

BlogCategory.propTypes = {
  category: PropTypes.string,
  categories: PropTypes.array,
};

BlogCategory.defaultProps = {
  category: '',
  categories: null,
};

BlogCategory.getInitialProps = async ({ res, query: { category } }) => {
  let categoryData = await api()
    .categories.where('label', category)
    .first();

  if (category === 'other') {
    categoryData = {
      blogCategory: 94,
      label: 'other',
    };
  }

  let categoryId;

  if (categoryData) {
    categoryId = categoryData.id;
  } else if (!process.browser) {
    res.statusCode = 404;
    return { category };
  }

  if (category === 'languages') {
    let categories = null;

    let languagesData;
    let coursetypesData;

    if (category) {
      languagesData = (await api()
        .languages.where('category', categoryId)
        .where('showBlog', true)
        .all())
        .map(o => ({
          id: o.blogCategory,
          label: o.label,
          categoryData: o,
        }))
        .filter(o => o.id);
      coursetypesData = (await api()
        .courseTypes.where('category', categoryId)
        .where('showBlog', true)
        .all())
        .map(o => ({
          id: o.blogCategory,
          label: o.label,
          categoryData: o,
        }))
        .filter(o => o.id);
      if (!languagesData.length && !coursetypesData.length) {
        if (!process.browser) {
          res.statusCode = 404;
        }
      } else {
        categories = [...languagesData, ...coursetypesData].sort((a, b) => {
          if (!a.blogOrderPriority) {
            return 1;
          }
          if (!b.blogOrderPriority) {
            return -1;
          }
          if (a.blogOrderPriority > b.blogOrderPriority) {
            return 1;
          }
          if (a.blogOrderPriority < b.blogOrderPriority) {
            return -1;
          }

          return 0;
        });
      }
    } else if (!process.browser) {
      res.statusCode = 404;
    }

    return { category, categories };
  }
  return {
    category,
    categories: [
      {
        id: categoryData.blogCategory,
        label: categoryData.label,
        categoryData,
      },
    ],
  };
};

export default BlogCategory;
